export type TableCellContentItem =
  | 'svg'
  | 'Limited'
  | 'Unlimited'
  | 'Bulk only'
  | 'Bulk and individual'
// Deprecated Lite plan, is hidden from the UI. Server-side validation in the Plan Change API will be done as a followup
export type DataTableItem = {
  header: string
  columns: {
    name: string
    props: string
  }[]
  data: {
    feature: {
      name: string
    }
    //'2020-lite'?: TableCellContentItem,
    '2020-plus'?: TableCellContentItem
    '2020-pro'?: TableCellContentItem
    '2020-enterprise'?: TableCellContentItem
  }[]
}
type DataTables = DataTableItem[]
export const dataTables: DataTables = [
  {
    header: 'File handling',
    columns: [
      {
        name: 'Feature',
        props: 'feature',
      }, //{ name: 'Lite', props: '2020-lite' },
      {
        name: 'Plus',
        props: '2020-plus',
      },
      {
        name: 'Pro',
        props: '2020-pro',
      },
      {
        name: 'Enterprise',
        props: '2020-enterprise',
      },
    ],
    data: [
      {
        feature: {
          name: 'Free catalog import',
        },
        //'2020-lite': 'svg',
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: '320kbps transcode option',
        },
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Catalog editing via CSV',
        },
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Custom file names for tracks and zips',
        },
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'WAV > AIFF & AIFF > WAV converter',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Ongoing DDEX ingestion',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
    ],
  },
  {
    header: 'Sharing and presentation',
    columns: [
      {
        name: 'Feature',
        props: 'feature',
      }, //{ name: 'Lite', props: '2020-lite' },
      {
        name: 'Plus',
        props: '2020-plus',
      },
      {
        name: 'Pro',
        props: '2020-pro',
      },
      {
        name: 'Enterprise',
        props: '2020-enterprise',
      },
    ],
    data: [
      {
        feature: {
          name: 'Pages',
        },
        //'2020-lite': 'svg',
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Embeds',
        },
        //'2020-lite': 'svg',
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Team and personal inbox',
        },
        //'2020-lite': 'svg',
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Playlist themes',
        },
        //'2020-lite': 'Limited',
        '2020-plus': 'Unlimited',
        '2020-pro': 'Unlimited',
        '2020-enterprise': 'Unlimited',
      },
      {
        feature: {
          name: 'Alias metadata',
        },
        '2020-plus': 'Bulk only',
        '2020-pro': 'Bulk and individual',
        '2020-enterprise': 'Bulk and individual',
      },
      {
        feature: {
          name: 'Assigned URLs',
        },
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Playlist format settings',
        },
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Email creator',
        },
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Kill share URLs',
        },
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Custom inboxes',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Password protected playlists',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Expiring share URLs',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Shareable channels',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Whitelabeling and css customizations',
        },
        '2020-enterprise': 'svg',
      },
    ],
  },
  {
    header: 'Search and organisation',
    columns: [
      {
        name: 'Feature',
        props: 'feature',
      }, //{ name: 'Lite', props: '2020-lite' },
      {
        name: 'Plus',
        props: '2020-plus',
      },
      {
        name: 'Pro',
        props: '2020-pro',
      },
      {
        name: 'Enterprise',
        props: '2020-enterprise',
      },
    ],
    data: [
      {
        feature: {
          name: 'Channels',
        },
        // '2020-lite': 'Limited',
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Custom fields',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Territory restrictions',
        },
        '2020-enterprise': 'svg',
      },
    ],
  },
  {
    header: 'Contact management, insights and reports',
    columns: [
      {
        name: 'Feature',
        props: 'feature',
      }, //{ name: 'Lite', props: '2020-lite' },
      {
        name: 'Plus',
        props: '2020-plus',
      },
      {
        name: 'Pro',
        props: '2020-pro',
      },
      {
        name: 'Enterprise',
        props: '2020-enterprise',
      },
    ],
    data: [
      {
        feature: {
          name: 'Contact management',
        },
        //'2020-lite': 'svg',
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Mailing lists',
        },
        //'2020-lite': 'svg',
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Playlist stats',
        },
        //'2020-lite': 'svg',
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Advanced playlist stats',
        },
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Insights',
        },
        '2020-plus': 'Limited',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Reports',
        },
        '2020-plus': 'Limited',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
    ],
  },
  {
    header: 'Support',
    columns: [
      {
        name: 'Feature',
        props: 'feature',
      }, //{ name: 'Lite', props: '2020-lite' },
      {
        name: 'Plus',
        props: '2020-plus',
      },
      {
        name: 'Pro',
        props: '2020-pro',
      },
      {
        name: 'Enterprise',
        props: '2020-enterprise',
      },
    ],
    data: [
      {
        feature: {
          name: '24 hour weekday chat support',
        },
        //'2020-lite': 'svg',
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Screenshare training',
        },
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'In person training (where available)',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Dedicated account manager',
        },
        '2020-enterprise': 'svg',
      },
    ],
  },
]
